(function() {
  const WISHLIST_KEY = 't4s_wis';
  const ADDED_CLASS = 'is--added';
  const ACTION_SELECTOR = '[data-action-wishlist]';
  const COUNT_SELECTOR = '[data-count-wishlist]';
  const LINK_SELECTOR = '[data-link-wishlist]';
  const SCROLL_KEY = 'prints10_wishlist_scroll';


  class Wishlist {
    constructor() {
      this.toastElement = document.getElementById('wishlist-toast'); 
      this.toastTimer = null; 
      this.wishlist = this.getWishlist();
      this.updateAll();
      this.bindEvents();
      this.restoreScrollPosition();
      this.observeWishlistGrid();
    }
    showToast(message) {
      if (!this.toastElement) return;
    
      clearTimeout(this.toastTimer); 
    
      this.toastElement.textContent = message;
      this.toastElement.classList.add('is-visible');
    
      this.toastTimer = setTimeout(() => {
        this.toastElement.classList.remove('is-visible');
      }, 3000); 
    }
        
    getWishlist() {
      const data = localStorage.getItem(WISHLIST_KEY);
      return data ? data.split(',') : [];
    }

    saveWishlist() {
      localStorage.setItem(WISHLIST_KEY, this.wishlist.join(','));
      this.updateAll();
    }

   toggleProduct(productId) {
      const index = this.wishlist.indexOf(productId);
      if (index > -1) {
        this.wishlist.splice(index, 1);
        this.showToast('Removed from wishlist');
      } else {
        this.wishlist.push(productId);
        this.showToast('Added to wishlist');
      }
      this.saveWishlist();
    }

    removeFromWishlist(productId, buttonElement) {
      const index = this.wishlist.indexOf(productId);
      if (index > -1) {
        this.wishlist.splice(index, 1);
        this.saveWishlist(); // 保存并更新 header
        this.showToast('Removed from wishlist'); // (如果做了优化1) 调用 Toast
    
        const url = new URL(window.location.href);
        url.searchParams.set('view', 'wishlist');
        if (this.wishlist.length > 0) {
          url.searchParams.set('type', 'product');
          url.searchParams.set('q', this.wishlist.map(id => `id:${id}`).join(' OR '));
          const page = Number(url.searchParams.get('page') || 1);
          const visibleCards = document.querySelectorAll('#product-grid .grid__item').length;
          // Move back only when deleting the only result on a later page.
          if (page > 1 && visibleCards === 1) {
            url.searchParams.set('page', String(page - 1));
          }
        } else {
          url.searchParams.delete('q');
          url.searchParams.delete('page');
        }
        try {
          sessionStorage.setItem(SCROLL_KEY, JSON.stringify({
            url: url.href, x: window.scrollX, y: window.scrollY
          }));
        } catch (_) { /* Removal still works when session storage is unavailable. */ }
        window.location.replace(url.href);
      }
    }

    observeWishlistGrid() {
      if (new URL(window.location.href).searchParams.get('view') !== 'wishlist') return;
      const grid = document.getElementById('ProductGridContainer');
      if (!grid) return;
      // Facet updates replace cards; restore their stored wishlist state.
      const observer = new MutationObserver(() => this.updateAll());
      observer.observe(grid, { childList: true, subtree: true });
    }

    restoreScrollPosition() {
      try {
        const saved = sessionStorage.getItem(SCROLL_KEY);
        sessionStorage.removeItem(SCROLL_KEY);
        if (!saved) return;
        const position = JSON.parse(saved);
        if (position.url !== window.location.href) return;
        const restore = () => window.requestAnimationFrame(() => {
          window.scrollTo(position.x, position.y);
        });
        if (document.readyState === 'complete') restore();
        else window.addEventListener('load', restore, { once: true });
      } catch (_) { /* Ignore stale or blocked session storage. */ }
    }

    updateButton(button) {
      const productId = button.dataset.productId;
      if (this.wishlist.includes(productId)) {
        button.classList.add(ADDED_CLASS);
        button.setAttribute('aria-label', button.querySelector('.wishlist-text--remove').textContent);
      } else {
        button.classList.remove(ADDED_CLASS);
        button.setAttribute('aria-label', button.querySelector('.wishlist-text--add').textContent);
      }
    }

    updateCount() {
      const count = this.wishlist.length;
    
      document.querySelectorAll(COUNT_SELECTOR).forEach(el => {
        // 如果 count > 0，则 display 为 'flex'，否则为 'none'。
        el.style.display = count > 0 ? 'flex' : 'none';
        
        // 无论如何都更新文本内容，
        // 因为即使元素被隐藏，保持数据的一致性也是个好习惯。
        el.textContent = count;
      });
    }
    
    updateHeaderLink() {
      const url = this.getWishlistUrl();
      document.querySelectorAll(LINK_SELECTOR).forEach(el => {
        el.href = url;
      });
    }

    updateAll() {
      document.querySelectorAll(ACTION_SELECTOR).forEach(button => this.updateButton(button));
      this.updateCount();
      this.updateHeaderLink(); // 调用新函数
    }
    
    getWishlistUrl() {
      if (this.wishlist.length === 0) {
        return '/search?view=wishlist';
      }
      const query = this.wishlist.map(id => `id:${id}`).join(' OR ');
      return `/search?view=wishlist&type=product&q=${encodeURIComponent(query)}`;
    }

    bindEvents() {
      document.body.addEventListener('click', (event) => {
        const button = event.target.closest(ACTION_SELECTOR);
        if (!button) return;
    
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
    
        const productId = button.dataset.productId.toString();
    
        if (new URL(window.location.href).searchParams.get('view') === 'wishlist') {
          this.removeFromWishlist(productId, button);
        } else {
          this.toggleProduct(productId);
        }
      });
      // 旧的点击劫持逻辑已完全移除
    }
  }

  new Wishlist();
})();